// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useVideosInfiniteQuery } from 'features/videos/queries';
import { ChannelsEmpty, EntityList } from '../../components';

type P = {
  getPathToVideoDetail: (id: string) => string;
  navigateToVideos: () => Promise<void>;
  organizationId?: string;
};

const AllVideos = ({ getPathToVideoDetail, navigateToVideos, organizationId }: P) => {
  const {
    data: allVideosData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useVideosInfiniteQuery({
    filter: { organizationId, scope: 'channels' },
    pagination: { pageSize: 12 },
  });

  const allVideos = allVideosData?.pages.flat().flatMap((videosPaginated) => videosPaginated.data);

  return (
    <EntityList
      empty={<ChannelsEmpty navigateToJoined={navigateToVideos} scope="videos" />}
      entities={allVideos?.map((video) => ({
        data: video,
        type: 'Video',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToVideoDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default AllVideos;
